var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter212(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(1, 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-38-Copy",
    stroke: "#8996A0",
    strokeWidth: 0.875
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    cx: 14,
    cy: 14,
    r: 13.5625
  }))), /*#__PURE__*/React.createElement("g", {
    id: "317720_social-media_tweet_twitter_social_icon",
    transform: "translate(7, 8)",
    fill: "#8996A0",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,1.42015385 C13.4849337,1.66153846 12.9317954,1.82446154 12.3502126,1.89692308 C12.9431733,1.52215385 13.3987247,0.928615385 13.6135909,0.221538462 C13.0582646,0.568153846 12.443861,0.821076923 11.7896349,0.956307692 C11.2653788,0.367846154 10.5188172,0 9.69217304,0 C8.10583896,0 6.82058015,1.356 6.82058015,3.02907692 C6.82058015,3.26630769 6.84552388,3.498 6.89453613,3.71953846 C4.50737684,3.59307692 2.39109777,2.38707692 0.97411853,0.554307692 C0.727306827,1.002 0.58552138,1.52215385 0.58552138,2.07738462 C0.58552138,3.12876923 1.09271068,4.05553846 1.86290323,4.59923077 C1.39247312,4.58307692 0.949612403,4.44738462 0.562328082,4.22030769 C0.561890473,4.23276923 0.561890473,4.24615385 0.561890473,4.25815385 C0.561890473,5.72630769 1.55176294,6.95076923 2.86590398,7.22907692 C2.6252188,7.29784615 2.37140535,7.33523077 2.10927732,7.33523077 C1.92373093,7.33523077 1.74431108,7.31630769 1.56926732,7.28123077 C1.93423356,8.484 2.99543636,9.36 4.25181295,9.38492308 C3.26937984,10.1972308 2.03094524,10.6823077 0.685296324,10.6823077 C0.453363341,10.6823077 0.224493623,10.668 0,10.6398462 C1.2708177,11.4983077 2.78057014,12 4.4027882,12 C9.6856089,12 12.5751438,7.38415385 12.5751438,3.38076923 C12.5751438,3.24969231 12.5716429,3.11861538 12.5663916,2.98846154 C13.1278445,2.56153846 13.6144661,2.02846154 14,1.42015385 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter212);
export default __webpack_public_path__ + "static/media/twitter212.a6eb4487aa01faaf7b1ca5c02a7ffb3f.svg";
export { ForwardRef as ReactComponent };